<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveArchive()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="description">Descrição</label>
                <input
                  id="description"
                  v-model="archive.description"
                  name="description"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.archive.description.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.archive.description.required"
                  class="invalid-feedback"
                >
                  O campo descrição é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="url_download">URL Download</label>
                <input
                  id="url_download"
                  v-model="archive.url_download"
                  name="url_download"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.archive.url_download.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.archive.url_download.required"
                  class="invalid-feedback"
                >
                  O campo url é obrigatório.
                </div>
                <div
              v-if="submitted && !$v.archive.url_download.url"
              class="invalid-feedback"
            >
              O campo url download deve ser uma URL válida
            </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveArchive()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required, url } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    idArchive: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo Arquivo',
      loading: true,
      fullPage: true,
      submitted: false,
      archive: {},
      modal: false
    }
  },
  validations: {
    archive: {
      description: { required },
      url_download: { required, url }
    }
  },
  methods: {
    ...mapActions('archive', {
      getArchive: 'show',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Arquivo'
        this.getArchive(id).then((data) => {
          this.archive = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveArchive () {
      this.submitted = true
      this.$v.archive.$touch()
      if (this.$v.archive.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.postData(this.archive).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.archive = {}
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('archive', { data: 'archive' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
